import Api from 'services/AirBaltic/Api'
import conf from 'conf'
import isEmpty from 'lodash-es/isEmpty'

class FlightSearch {
  onewayFlight(data) {
    return new Api()
      .get(
        `/schedule/fsf/calendar/ONEWAY/${data.origin}/${data.destination}${conf.btUrlCors}`,
        {},
        {
          timeout: 10000
        }
      )
      .then((response) => this.modifyResponse(response.data, 'outbound'))
      .catch(() => Promise.reject())
  }

  returnFlights(data) {
    return new Api()
      .get(
        `/schedule/fsf/calendar/RETURN/${data.origin}/${data.destination}/${data.dateFrom}/${data.dateTo}${conf.btUrlCors}`,
        {},
        {
          timeout: 10000
        }
      )
      .then((response) => this.modifyResponse(response.data, 'outbound'))
      .catch(() => Promise.reject())
  }

  returnFlightPrice(data) {
    return new Api()
      .get(
        `/schedule/fsf/calendar/RETURN/${data.origin}/${data.destination}/${data.date}${conf.btUrlCors}`,
        {},
        {
          timeout: 10000
        }
      )
      .then((response) => this.modifyResponse(response.data, 'inbound'))
      .catch(() => Promise.reject())
  }

  returnYearFlightPrices(data) {
    return new Api()
      .get(
        `/schedule/fsf/calendar/year/RETURN/${data.origin}/${data.destination}${conf.btUrlCors}`,
        {},
        {
          timeout: 10000
        }
      )
      .then((response) => this.modifyYearResponse(response.data))
      .catch(() => Promise.reject())
  }

  onewayYearFlightPrices(data) {
    return new Api()
      .get(
        `/schedule/fsf/calendar/year/ONEWAY/${data.origin}/${data.destination}${conf.btUrlCors}`,
        {},
        {
          timeout: 10000
        }
      )
      .then((response) => this.modifyYearResponse(response.data))
      .catch(() => Promise.reject())
  }

  modifyResponse(data, key) {
    if (isEmpty(data)) {
      return Promise.reject()
    }
    let flightData = []
    const priceKey = `${key}Price`
    const dateKey = `${key}Date`

    data.forEach((value) => {
      const price = this.formatPrice(value.price)
      const inboundPrice = this.formatPrice(value.inboundPrice)
      const outboundPrice = this.formatPrice(value.outboundPrice)

      flightData.push({
        customData: {
          price: this.getMainPrice(price),
          decimalPrice: this.getDecimalPrice(price),
          isDirect: value.isDirect,
          inboundPrice: this.getMainPrice(inboundPrice),
          inboundDecimalPrice: this.getDecimalPrice(inboundPrice),
          outboundPrice: this.getMainPrice(outboundPrice),
          outboundDecimalPrice: this.getDecimalPrice(outboundPrice)
        },
        dates: value.date || value[dateKey]
      })
    })

    const notNullPrice = flightData
      .map((flight) => flight.customData[priceKey])
      .filter((price) => price !== null)

    const cheapestPrice = Math.min(...notNullPrice)

    const flightWithCheapestPrice = flightData.map((flight) => ({
      ...flight,
      customData: {
        ...flight.customData,
        lowestPrice: flight.customData[priceKey] === cheapestPrice
      }
    }))

    return Promise.resolve(flightWithCheapestPrice)
  }

  modifyYearResponse(data) {
    if (isEmpty(data)) {
      return Promise.reject()
    }
    let flightData = []
    data.forEach((value) => {
      const [year, month] = value.date.split('-')
      const outboundPrice = this.formatPrice(value.outboundPrice)

      flightData.push({
        outboundPrice: this.getMainPrice(outboundPrice),
        outboundDecimalPrice: this.getDecimalPrice(outboundPrice),
        hasFlight: value.hasFlight,
        year,
        month
      })
    })
    return Promise.resolve(flightData)
  }

  formatPrice(price) {
    if (!price) return null

    return price.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: false
    })
  }

  getMainPrice(price) {
    return Math.trunc(price) || null
  }

  getDecimalPrice(price) {
    if (!price) return null
    return price?.toString().split('.')[1] || null
  }
}

export default FlightSearch
